import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import dayjs from "dayjs";
import "./confirmyourchoices.scss";
import {
  popupBlockerText,
  RA_STEPS_IDENTIFIERS,
} from "../../constants/constants";
import { addCommas } from "../../helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { actionCreators } from "../../redux/actions";
import { bindActionCreators } from "redux";
import LoadingSpinner from "../../atoms/Loader";
import NotFound from "../../atoms/NotFound";
import LabelText from "../../atoms/LabelText";

const ConfirmYourChoices = (props) => {
  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");
  const {
    chooseRetirementSteps,
    choose,
    data,
    regularchoice,
    annuityprovider,
    mixmatchchoice,
    mixmatch,
    investrest,
    moneyinchunk,
    regularincome,
    taxfreecash,
    annuitychoice,
  } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const {
    illustrationFetching,
    illustrationError, // eslint-disable-line
  } = useSelector(
    (state) => state.viewIllustration // eslint-disable-line
  );

  const dispatch = useDispatch();
  const { getIllustrationContent } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );

  const isActiveMember = props?.isActiveMember;
  const { isFinalPage, setIsFinalPage } = props;

  useEffect(() => {
    const isFinal = handleFinalPage();
    setIsFinalPage(isFinal);
  }, [chooseRetirementSteps, taxfreecash]);

  const handleFinalPage = () => {
    if (
      (chooseRetirementSteps?.isTakeMoneyInOneGo ||
        chooseRetirementSteps?.isTakeMoneyInOneChunk ||
        chooseRetirementSteps?.isAnnuityHowMuchCash ||
        chooseRetirementSteps?.isRegularHowMuchCash ||
        chooseRetirementSteps?.isMixMatchHowMuchCash) &&
      !isActiveMember
    ) {
      return true;
    } else if (
      chooseRetirementSteps?.isTakeTaxFreeCashInvestRest &&
      (taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome ||
        (!taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome &&
          !isActiveMember))
    ) {
      return true;
    } else {
      return false;
    }
  };

  const potSelectionData =
    Object.keys(choose)?.length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;

  const regularIncome = regularincome?.choiceCategory?.regularIncome;
  const mixNMatchIncome = mixmatch?.choiceCategory?.mixNmatch?.investTheRest;

  const mixMatchSelected =
    mixmatchchoice?.choiceCategory?.mixNmatch?.cashLumpsum?.amount;

  const mixMatchSelectedPercentage =
    mixmatchchoice?.choiceCategory?.mixNmatch?.cashLumpsum?.percentage;

  const mmTaxFree =
    mixMatchSelectedPercentage > 25
      ? (25 * potSelectionData?.monetaryChosenAmount) / 100
      : (mixMatchSelectedPercentage * potSelectionData?.monetaryChosenAmount) /
        100;

  const mmTaxable =
    mixMatchSelectedPercentage > 25
      ? ((mixMatchSelectedPercentage - 25) *
          potSelectionData?.monetaryChosenAmount) /
        100
      : 0;
  const [readStatus, setReadStatus] = useState(false);
  const [riskStatus, setRiskStatus] = useState(false);
  const [moreContribution, setmoreContribution] = useState(null); //eslint-disable-line

  const [smallPotInfoRead, setSmallPotInfoRead] = useState(false);
  const [isControllingDirector, setIsControllingDirector] = useState(null);
  const [illustrationConfirmationBox, setIllustrationConfirmationBox] =
    useState(null);
  const applicationPotsSelected =
    data?.applicationPots?.length > 0
      ? data?.applicationPots
      : JSON.parse(localStorage.getItem("applicationPots"));

  const handleBack = () => {
    if (chooseRetirementSteps?.isTakeMoneyInOneGo) {
      props.makeInitialStepper(false, 33, { isRetirementChoice: true }, true);
    } else if (chooseRetirementSteps?.isTakeMoneyInOneChunk) {
      props.makeInitialStepper(
        false,
        34,
        { isTakeMoneyInOneChunk: true },
        true //eslint-disable-line
      );
    } else if (chooseRetirementSteps?.isAnnuityHowMuchCash) {
      props.makeInitialStepper(false, 35, { isAnnuity: true }, true);
    } else if (chooseRetirementSteps?.isRegularHowMuchCash) {
      props.makeInitialStepper(
        false,
        35,
        { isTakingRegularIncome: true },
        true //eslint-disable-line
      );
    } else if (chooseRetirementSteps?.isMixMatchHowMuchCash) {
      props.makeInitialStepper(false, 35, { isMixandMatch: true }, true);
    } else if (
      chooseRetirementSteps?.isTakeTaxFreeCashInvestRest &&
      !taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome
    ) {
      props.makeInitialStepper(false, 35, { isInvestRest: true }, true);
    } else if (
      chooseRetirementSteps?.isTakeTaxFreeCashInvestRest &&
      taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome
    ) {
      props.makeInitialStepper(
        false,
        34,
        { isTakeTaxFreeCashInvestRest: true },
        true //eslint-disable-line
      );
    }
  };

  const handleIllustration = (item) => {
    const movingToDrawdown = parseFloat(
      item?.potMonetaryAmount *
        (taxfreecash?.choiceCategory?.taxFreeCash?.percenateLumpsum / 100) *
        3 //eslint-disable-line
    );
    const payload = {
      //eslint-disable-line
      investorId: props.investorId,
      investorAccountId: Number(item?.potId),
      incomeFrequency: 12,
      targetTfcPercentage:
        taxfreecash?.choiceCategory?.taxFreeCash?.percenateLumpsum.toString(),
      incomeAmount: movingToDrawdown.toFixed(2).toString(),
      pensionSavingMem: item?.potId.toString(),
      totalBalance: parseFloat(item?.potValue?.toFixed(2)),
      taxFreeCash: parseFloat(
        (
          item?.potMonetaryAmount *
          (taxfreecash?.choiceCategory?.taxFreeCash?.percenateLumpsum / 100)
        ).toFixed(2) //eslint-disable-line
      ),
      taxableLumpSums: parseFloat(
        (
          item?.potValue -
          item?.potMonetaryAmount *
            (taxfreecash?.choiceCategory?.taxFreeCash?.percenateLumpsum / 100)
        ).toFixed(2) //eslint-disable-line
      ),
      taxablePensionSavings: parseFloat(movingToDrawdown.toFixed(2)), //eslint-disable-line

      requestedInvestment: [
        {
          managedIncome: {
            fundid: 0,
            fundValue: 0,
          },
          futureAnnuity: {
            fundid: 0,
            fundValue: 0,
          },

          flexiAccess: {
            fundValue: parseFloat(
              (
                movingToDrawdown *
                (investrest?.choiceCategory?.taxFreeCash?.investTheRest
                  ?.investRestFlexiAccessPerc /
                  100)
              ).toFixed(2) //eslint-disable-line
            ),
          },

          safetyNet: {
            fundid: investrest?.choiceCategory?.taxFreeCash?.investTheRest
              ?.safetyNet
              ? props.snId
              : 0,
            fundValue:
              movingToDrawdown *
              (
                investrest?.choiceCategory?.taxFreeCash?.investTheRest
                  ?.investRestsafetyNetPer / 100
              ).toFixed(2),
          },

          legacy: {
            fundid: investrest?.choiceCategory?.taxFreeCash?.investTheRest
              ?.legacy
              ? props.leId
              : 0,
            fundValue:
              movingToDrawdown *
              (
                investrest?.choiceCategory?.taxFreeCash?.investTheRest
                  ?.investRestLegacyPerc / 100
              ).toFixed(2),
          },
        },
      ],
      managedIncomePaymentPerMonth: "0",
      futureAnnuityIncomePaymentPerMonth: "0",
      futureFlexiAccessPaymentAmount: (
        (movingToDrawdown *
          (investrest?.choiceCategory?.taxFreeCash?.investTheRest
            ?.investRestFlexiAccessPerc /
            100)) /
        12
      )
        .toFixed(2)
        .toString(),
      flexiAccessIncomePaymentFrequency: "Monthly",
      totalRegularIncome: movingToDrawdown.toFixed(2).toString(),
      retirementId: props.retirementId ? props.retirementId : 0,
    };
    handleIllustrationClick(payload);
  };
  const handleIllustrationClick = async (payload) => {
    try {
      const result = await getIllustrationContent(payload);
      const base64String = result?.encodedPdf;

      if (!base64String) {
        alert("Document content not found.");
        return;
      }

      const byteCharacters = atob(base64String);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error opening document:", error);
      alert("Failed to open document.");
    }
  };
  const handleContinue = () => {
    if (chooseRetirementSteps?.isTakeMoneyInOneGo === true) {
      let currentStep = RA_STEPS_IDENTIFIERS.RA_TAKE_ALL_IN_ONE_GO;
      let takeAllInOneGo = {
        active: true,
        lumpsumTaken: parseFloat(potSelectionData?.monetaryChosenAmount),
      };
      let payload = {
        currentStep,
        choiceCategory: {
          takeAllInOneGo,
          declaration: {
            read: smallPotInfoRead,
            isControllingDirector: isControllingDirector,
          },
          moreContributions: isActiveMember,
          choiceSubmitted: isFinalPage,
          choiceSelected: isFinalPage ? "TAKE_ALL_IN_ONE_GO" : "",
        },
      };

      props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE, {
        ...payload,
        ...(isActiveMember && { moreContribution: isActiveMember }),
      });
    } else if (chooseRetirementSteps?.isTakeTaxFreeCashInvestRest === true) {
      let currentStep = RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE;
      let choiceCategory;
      if (taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome) {
        choiceCategory = {
          moreContributions: false,
          choiceSubmitted: isFinalPage,
          choiceSelected: isFinalPage
            ? "TAKE_TAX_FREE_CASH_REGULAR_INCOME_INVEST_THE_REST"
            : "",
        };
      } else {
        choiceCategory = {
          illustration: { terms: illustrationConfirmationBox },
          moreContributions: moreContribution,
          choiceSubmitted: isFinalPage,
          choiceSelected: isFinalPage
            ? "TAKE_TAX_FREE_CASH_LUMSUM_INVEST_THE_REST"
            : "",
        };
      }
      let payload = {
        currentStep,
        choiceCategory,
      };
      taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome
        ? props.nextStepIndentifier(
            RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE,
            payload // eslint-disable-line
          )
        : props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE, {
            ...payload,
            ...(isActiveMember && { moreContribution: isActiveMember }),
          });
    } else if (chooseRetirementSteps?.isTakeMoneyInOneChunk === true) {
      let currentStep = RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE;
      let choiceCategory = {
        declaration: {
          read: readStatus,
          risk: riskStatus,
        },
        moreContributions: isActiveMember,
        choiceSubmitted: isFinalPage,
        choiceSelected: isFinalPage ? "TAKE_MONEY_IN_CHUNKS" : "",
      };
      let payload = {
        currentStep,
        choiceCategory,
      };
      props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE, {
        ...payload,
        ...(isActiveMember && { moreContribution: isActiveMember }),
      });
    } else if (chooseRetirementSteps?.isRegularHowMuchCash) {
      let currentStep = RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE;
      let choiceCategory = {
        declaration: {
          read: readStatus,
          risk: riskStatus,
        },
        moreContributions: isActiveMember,
      };
      let payload = {
        currentStep,
        choiceCategory,
      };
      props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE, {
        ...payload,
        ...(isActiveMember && { moreContribution: isActiveMember }),
      });
    } else if (chooseRetirementSteps?.isAnnuityHowMuchCash) {
      let currentStep = RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE;
      let choiceCategory = {
        moreContributions: isActiveMember,
        choiceSubmitted: isFinalPage,
        choiceSelected: isFinalPage ? "TAKE_GUARANTEED_INCOME_ANNUITY" : "",
      };
      let payload = {
        currentStep,
        choiceCategory,
      };
      props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE, {
        ...payload,
        ...(isActiveMember && { moreContribution: isActiveMember }),
      });
    } else if (chooseRetirementSteps?.isMixMatchHowMuchCash) {
      let currentStep = RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE;
      let choiceCategory = {
        moreContributions: isActiveMember,
      };
      let payload = {
        currentStep,
        choiceCategory,
      };
      props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE, {
        ...payload,
        ...(isActiveMember && { moreContribution: isActiveMember }),
      });
    }
  };

  const isDisabled = (() => {
    if (
      chooseRetirementSteps?.isTakeMoneyInOneGo === true &&
      smallPotInfoRead &&
      isControllingDirector !== null
    ) {
      return false;
    } else if (chooseRetirementSteps?.isAnnuityHowMuchCash === true) {
      return false;
    } else if (
      chooseRetirementSteps?.isTakeMoneyInOneChunk === true ||
      chooseRetirementSteps?.isRegularHowMuchCash === true
    ) {
      if (readStatus && riskStatus) {
        return false;
      }
    } else if (chooseRetirementSteps?.isTakeTaxFreeCashInvestRest === true) {
      if (
        !taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome &&
        illustrationConfirmationBox
      ) {
        return false;
      } else if (taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome) {
        return false;
      }
    } else if (chooseRetirementSteps?.isMixMatchHowMuchCash === true) {
      return false;
    }

    return true;
  })();

  const checkConfirmations = [
    {
      checkboxName: "confirmationsread",
      value: "read",
      label: (
        <>
          <strong>I have read through all information</strong> provided and am
          happy to go ahead with the option(s) selected
        </>
      ),
    },
    {
      checkboxName: "confirmationsrisk",
      value: "risk",
      label: (
        <>
          <strong>I have read the risk warnings</strong> associated with my
          choices and I’m happy to go ahead with the options selected
          {chooseRetirementSteps?.isTakeTaxFreeCashInvestRest === true ? (
            <ul className="mt-2 ">
              <li className="mb-1">
                Tax-free cash, invest the rest (flexi-access drawdown)
              </li>
              <li>
                Tax-free cash, invest the rest (managed for you – safety net and
                legacy)
              </li>
            </ul>
          ) : (
            ""
          )}
        </>
      ),
    },
  ];
  const takeAllInOneGoCheckConfirmations = [
    {
      checkboxName: "confirmationsread",
      value: "smallPotInfo",
      label: (
        <>
          I accept that if I am ineligible for a &apos;Small pots&apos; my lump
          sum will be paid as an UFPLS (which would trigger the money purchase
          annual allowance).
        </>
      ),
    },
  ];

  const checkBoxContribution = [
    {
      checkboxName: "controllingDirector",
      value: "yes",
      label: "Yes",
    },
    {
      checkboxName: "controllingDirector",
      value: "no",
      label: "No",
    },
  ];

  const smallPotBenefitsToolTip = (
    <Popover id="popover-contained" className="tooltip-popover-section">
      <Popover.Body className="tooltip-popover-body">
        <p>
          A small pot may be an option when your entire pension pot is worth
          less than £10,000.
        </p>
        <p>
          You take your entire pension pot as a lump sum - usually, the first
          25% will be tax-free. The remaining 75% will be taxed as earnings.
        </p>
        <p>
          &apos;Small pots&apos; works slightly differently to the standard ways
          of taking your pension flexibly, in that you have to stop membership
          of the plan and there are rules we would need to check whether you had
          transferred in or out in the past few years. This is because for small
          pots, no other tests against the value of retirement benefits apply.
        </p>
        <p>
          To be eligible for a small pot you must not be a controlling director
          i.e., a director controlling over 20% share capital of a sponsoring
          employer or related scheme (or a person connected to a controlling
          director).
        </p>
      </Popover.Body>
    </Popover>
  );

  const potUsedOfTotalIndividualPotTakeAllInOneGo =
    potSelectionData?.monetaryChosenAmount /
    potSelectionData?.monetaryActualAmount;

  const potUsedOfTotalIndividualPotMoneyInChunks =
    moneyinchunk?.choiceCategory?.takeMoneyInChunks?.lumpSumAmt /
    potSelectionData?.monetaryChosenAmount;

  const individualPotTaxFreePercentageForTaxFreeCash =
    taxfreecash?.choiceCategory?.taxFreeCash?.percenateLumpsum / 100;

  const estimatedNoOfPaymentsForRegularIncome = taxfreecash?.choiceCategory
    ?.taxFreeCash?.isRegularincome
    ? (potSelectionData?.monetaryChosenAmount * 0.25) /
      taxfreecash?.choiceCategory?.taxFreeCash?.regularIncomePayment
    : 0;

  const percentageTaxFreeForRegularIncome =
    taxfreecash?.choiceCategory?.taxFreeCash?.regularIncomePayment /
    potSelectionData?.monetaryChosenAmount;

  const mmTaxFreeIndividualPercentage =
    mmTaxFree / potSelectionData?.monetaryChosenAmount; //eslint-disable-line

  const mmTaxableIndividualPercentage =
    mmTaxable / potSelectionData?.monetaryChosenAmount; //eslint-disable-line
  return (
    <Card className="application-step">
      <Card.Body className="confirm-your-choices">
        <Row>
          <Col md={12} className="mb-fourty">
            <h2 className="heading">Confirm your choices</h2>
          </Col>
        </Row>
        {chooseRetirementSteps?.isTakeMoneyInOneGo === true ? (
          <div className="all-money-in-one-go-confirm">
            <div>
              <h3 className="sub-header">Your retirement choices</h3>

              <p className="bold-text">
                You&apos;ve chosen to take all your money in one go
              </p>
            </div>
            <Row>
              {applicationPotsSelected?.map((item) => (
                <Col lg={12} md={12} className="mb-3" key={item.potId}>
                  <Row>
                    <Col lg={4} md={4}>
                      Retiring with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      <span>
                        {item.potId}&nbsp;&nbsp;{item.potName}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4}>
                      Your pension pot(s):
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" + addCommas(item.potValue.toFixed(2))}
                    </Col>
                  </Row>
                  {potUsedOfTotalIndividualPotTakeAllInOneGo * 100 !== 100 && (
                    <>
                      <Row>
                        <Col lg={4} md={4}>
                          Total lump sum taken:
                        </Col>
                        <Col lg={8} md={8} className="bold-text">
                          {"£" +
                            addCommas(
                              (
                                item.potValue *
                                potUsedOfTotalIndividualPotTakeAllInOneGo
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row>
                    <Col lg={4} md={4}>
                      Of which tax-free cash:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                            0.25
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4}>
                      Of which taxable cash:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                            0.75
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                </Col>
              ))}
              <div className="text-end">
                {" "}
                Values correct as of {todayDate}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover
                      id="popover-contained"
                      className="tooltip-popover-section"
                    >
                      <Popover.Body className="tooltip-popover-body">
                        <p>
                          {" "}
                          All the values are estimates, based on the most
                          accurate information available. They include all the
                          contributions paid by you and your employer.
                        </p>
                        <p>
                          The value of your pension savings is based on current
                          financial conditions and is not guaranteed. The
                          amounts you receive may be higher or lower than the
                          amounts shown above. Payment of your pension will be
                          subject to TPT’s Trust Deed and Rules, and regulatory
                          requirements.
                        </p>{" "}
                      </Popover.Body>
                    </Popover>
                  }
                  flip={true}
                >
                  <span className="textarea-tooltip ms-1">
                    <Icons iconname="tool-tip" variant="icon-twelve-px" />
                  </span>
                </OverlayTrigger>
              </div>
            </Row>
            {parseFloat(potSelectionData?.monetaryActualAmount) < 10000 && (
              <Row>
                <div>
                  <h3 className="sub-header">
                    Small pot benefits
                    <OverlayTrigger
                      placement="right"
                      overlay={smallPotBenefitsToolTip}
                    >
                      <span className="icon-margin ms-2">
                        <Icons iconname="tool-tip" variant="icon-sixteen-px" />
                      </span>
                    </OverlayTrigger>
                  </h3>
                  <p>
                    You are retiring with your total pot valued at less than
                    £10,000. We will check whether you are entitled to process
                    this withdrawal as a ‘small pot’ which has the benefit of
                    not triggering the Money Purchase Annual Allowance (MPAA).
                    If this payment is ineligible for treatment as a small pot,
                    it will be processed as an Uncrystallised Fund Pension Lump
                    Sum(UFPLS), triggering the money purchase annual allowance.
                  </p>
                  <p>
                    Your payment letter will confirm whether we’ve been able to
                    process your payment as a small pot. Please check your
                    Documents when we email you that it’s ready to view.
                  </p>
                </div>
              </Row>
            )}

            <div className="your-confirmations">
              <h3 className="sub-header">Your confirmations</h3>
              <div className="check-box">
                {takeAllInOneGoCheckConfirmations?.map((item, index) => (
                  <span key={index}>
                    <CustomCheckbox
                      name={item.checkboxName}
                      type="checkbox"
                      label={item.label}
                      variantName="custom-checkbox mt-3"
                      checked={smallPotInfoRead}
                      onChange={(e) => setSmallPotInfoRead(e.target.checked)}
                    />
                  </span>
                ))}
              </div>
            </div>

            <div className="tax-free">
              <p>
                Are you a controlling director of this scheme or related scheme,
                or connected to such a person?
              </p>
              <div className="check-box harizontal">
                {checkBoxContribution?.map((item, index) => {
                  return (
                    <span key={index}>
                      <CustomCheckbox
                        name={item.checkboxName}
                        label={item.label}
                        variantName="custom-checkbox mt-3"
                        onChange={() => {
                          if (item.value === "yes") {
                            setIsControllingDirector(true);
                            //setmoreContribution(true);
                            //retirementConfirmChoiceStepHandler("YES");
                          } else {
                            setIsControllingDirector(false);
                            //retirementConfirmChoiceStepHandler("NO");
                            //setmoreContribution(false);
                          }
                        }}
                      />
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        ) : chooseRetirementSteps?.isTakeTaxFreeCashInvestRest === true ? (
          <div className="tax-free-cash-invest-rest">
            <div>
              <p>
                {taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome
                  ? "You've chosen to take your tax-free cash as income and invest the rest"
                  : "You've chosen to take your tax-free cash as a lump sum and invest the rest"}
              </p>
              <h3 className="sub-header">Your retirement choices</h3>
            </div>
            <Row>
              {applicationPotsSelected?.map((item) => (
                <Col lg={12} md={12} className="mb-3" key={item.potId}>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Retiring with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      <span>
                        {item.potId}&nbsp;&nbsp;{item.potName}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Applying with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  {taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome ? (
                    <>
                      <Row className="mb-1">
                        <Col lg={4} md={4}>
                          Taking as tax-free cash:
                        </Col>
                        <Col lg={8} md={8} className="bold-text">
                          {"£" +
                            addCommas(
                              (
                                percentageTaxFreeForRegularIncome *
                                item.potValue *
                                potUsedOfTotalIndividualPotTakeAllInOneGo
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col lg={4} md={4}>
                          Moving to drawdown:
                        </Col>
                        <Col lg={8} md={8} className="bold-text">
                          {"£" +
                            addCommas(
                              (
                                3 *
                                percentageTaxFreeForRegularIncome *
                                item.potValue *
                                potUsedOfTotalIndividualPotTakeAllInOneGo
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col lg={4} md={4}>
                          Payable until:
                        </Col>
                        <Col lg={8} md={8} className="bold-text">
                          {
                            taxfreecash?.choiceCategory?.taxFreeCash
                              ?.regularIncomePensionLastDate // eslint-disable-line
                          }
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row className="mb-1">
                        <Col lg={4} md={4}>
                          Taking as tax-free cash:
                        </Col>
                        <Col lg={8} md={8} className="bold-text">
                          {"£" +
                            addCommas(
                              (
                                item.potValue *
                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                individualPotTaxFreePercentageForTaxFreeCash
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col lg={4} md={4}>
                          Moving to drawdown:
                        </Col>
                        <Col lg={8} md={8} className="bold-text">
                          {"£" +
                            addCommas(
                              (
                                3 *
                                item.potValue *
                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                individualPotTaxFreePercentageForTaxFreeCash
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>
              ))}
            </Row>
            <div className="drawdown mb-4">
              <Card.Body>
                <Card>
                  <h3 className="sub-header mt-1">TPT drawdown selection</h3>
                  <div className="retirement-choice">
                    <div className="retiring-section taxfree-cash">
                      <Row>
                        <Col md={12}>
                          <Row>
                            {(taxfreecash?.choiceCategory?.taxFreeCash
                              ?.isRegularincome ||
                              investrest?.choiceCategory?.taxFreeCash
                                ?.investTheRest?.investRestFlexiAccessPerc >
                                0) && (
                              <>
                                <Col md={6}>Flexi-access</Col>
                                <Col md={6} className="bold-text">
                                  {taxfreecash?.choiceCategory?.taxFreeCash
                                    ?.isRegularincome
                                    ? "100%"
                                    : investrest?.choiceCategory?.taxFreeCash
                                        ?.investTheRest
                                        ?.investRestFlexiAccessPerc + "%"}
                                </Col>
                              </>
                            )}
                          </Row>
                          {!taxfreecash?.choiceCategory?.taxFreeCash
                            ?.isRegularincome && (
                            <>
                              {investrest?.choiceCategory?.taxFreeCash
                                ?.investTheRest?.investRestsafetyNetPer > 0 && (
                                <Row>
                                  <Col md={6}>Safety net</Col>
                                  <Col md={6} className="bold-text">
                                    {investrest?.choiceCategory?.taxFreeCash
                                      ?.investTheRest?.investRestsafetyNetPer +
                                      "%"}
                                  </Col>
                                </Row>
                              )}
                              {investrest?.choiceCategory?.taxFreeCash
                                ?.investTheRest?.investRestLegacyPerc > 0 && (
                                <Row>
                                  <Col md={6}>Legacy</Col>
                                  <Col md={6} className="bold-text">
                                    {investrest?.choiceCategory?.taxFreeCash
                                      ?.investTheRest?.investRestLegacyPerc +
                                      "%"}
                                  </Col>
                                </Row>
                              )}
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Card>
              </Card.Body>

              <div className=" m-35 d-flex align-items-center value-correct-date">
                <div>
                  {" "}
                  Values correct as of {todayDate}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Popover
                        id="popover-contained"
                        className="tooltip-popover-section"
                      >
                        <Popover.Body className="tooltip-popover-body">
                          <p>
                            {" "}
                            All the values are estimates, based on the most
                            accurate information available. They include all the
                            contributions paid by you and your employer.
                          </p>
                          <p>
                            The value of your pension savings is based on
                            current financial conditions and is not guaranteed.
                            The amounts you receive may be higher or lower than
                            the amounts shown above. Payment of your pension
                            will be subject to TPT’s Trust Deed and Rules, and
                            regulatory requirements.
                          </p>{" "}
                        </Popover.Body>
                      </Popover>
                    }
                    flip={true}
                  >
                    <span className="textarea-tooltip ms-1">
                      <Icons iconname="tool-tip" variant="icon-twelve-px" />
                    </span>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            <hr />

            {!taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome ? (
              <div className="your-confirmations mt-4">
                <h3 className="sub-header">Illustrations for retirement</h3>
                <p>
                  We have put together an illustration detailing how you your
                  choice will affect your savings. Click to access your
                  illustration document(s).
                </p>
                {applicationPotsSelected?.map((item) => (
                  <div key={item.id}>
                    <Col md={4} key={item.id} className="mb-2">
                      <a
                        className="tertiary w-auto download-btn"
                        rel="noreferrer"
                        onClick={() => {
                          handleIllustration(item);
                        }}
                      >
                        {item?.potId + "_Illustration.pdf"}
                      </a>
                    </Col>
                    {illustrationFetching ? <LoadingSpinner /> : ""}
                    {illustrationError ? (
                      <NotFound err="Unable to load illustration" />
                    ) : (
                      ""
                    )}
                  </div>
                ))}
                <LabelText text={popupBlockerText} />
                <Row>
                  <div className="illustration-confirmation mt-3">
                    {" "}
                    Your confirmations
                  </div>
                  <Col md={12} className="bg-text">
                    <div className="check-box">
                      <CustomCheckbox
                        type="checkbox"
                        name="pension-wise-guidance"
                        label="I have read through my illustrations and agree to continue"
                        variantName="custom-checkbox mt-3"
                        checked={illustrationConfirmationBox}
                        onChange={() => {
                          setIllustrationConfirmationBox(
                            !illustrationConfirmationBox //eslint-disable-line
                          );
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            ) : (
              <>
                <div className="regular-income-explainer-section">
                  <p className="fw-bold">
                    We estimate that your may receive{" "}
                    {Math.ceil(estimatedNoOfPaymentsForRegularIncome)} payments
                    of tax-free cash as income (no allowance has been made for
                    the future change in value of your account or future
                    contributions).
                  </p>
                  <p>
                    Your first tax-free income will be paid as soon as possible,
                    usually in 8 working days. Subsequest payments will be made
                    on or near the anniversary of this application, in the
                    frequency that you have received.
                  </p>
                </div>
              </>
            )}
          </div>
        ) : chooseRetirementSteps?.isTakeMoneyInOneChunk === true ? (
          <div className="money-in-chunk">
            <div>
              <h3 className="sub-header">Your retirement choices</h3>

              <p className="bold-text">
                You&apos;ve chosen to take your money in chunks
              </p>
            </div>
            <Row>
              {applicationPotsSelected?.map((item) => (
                <Col lg={12} md={12} className="mb-3" key={item.potId}>
                  {" "}
                  <Row>
                    <Col lg={4} md={4}>
                      Retiring with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      <span>
                        {item.potId}&nbsp;&nbsp;{item.potName}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4}>
                      Applying with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4}>
                      Amount withdrawn:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                            potUsedOfTotalIndividualPotMoneyInChunks
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4}>
                      Of which tax-free cash:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                            potUsedOfTotalIndividualPotMoneyInChunks *
                            0.25
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4}>
                      Of which taxable cash:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                            potUsedOfTotalIndividualPotMoneyInChunks *
                            0.75
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                </Col>
              ))}
            </Row>

            <div className="your-confirmations">
              <h3 className="sub-header">Your confirmations</h3>
              <div className="check-box">
                {checkConfirmations?.map((item, index) => {
                  return (
                    <span key={index}>
                      <CustomCheckbox
                        name={item.checkboxName}
                        type="checkbox"
                        label={item.label}
                        variantName="custom-checkbox mt-3"
                        onChange={() => {
                          if (item.value === "read") {
                            setReadStatus(!readStatus);
                          } else {
                            setRiskStatus(!riskStatus);
                          }
                        }}
                      />
                    </span>
                  );
                })}
              </div>
              <div className="all-money">
                Lump sum in stages -{" "}
                <a
                  className="risk-warning-links"
                  href="https://tpt.co.uk/risk-warnings"
                  target="_blank"
                  rel="noreferrer"
                >
                  tpt.co.uk/risk-warnings
                </a>
              </div>
            </div>
          </div>
        ) : chooseRetirementSteps?.isRegularHowMuchCash === true ? (
          <div className="take-regular-income mt-2">
            <p>You’ve chosen a TPT drawdown account</p>

            <div>
              <h3 className="sub-header">Your retirement choices</h3>
            </div>
            <Row>
              {applicationPotsSelected?.map((item) => (
                <Col lg={12} md={12} className="mb-3" key={item.potId}>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Retiring with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      <span>
                        {item.potId}&nbsp;&nbsp;{item.potName}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Applying with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Of which tax-free cash:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                            (regularchoice?.choiceCategory?.regularIncome
                              ?.percentage /
                              100)
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Moving to drawdown:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                            ((100 -
                              regularchoice?.choiceCategory?.regularIncome
                                ?.percentage) /
                              100)
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                </Col>
              ))}
            </Row>
            <Row className="mt-4 mb-2 d-flex flex-wrap">
              {regularIncome?.miAllocationPercent > 0 && (
                <Col xs={12} sm={6} lg={6} md={6} xl={4}>
                  <div className="tile">
                    <h3 className="sub-header">Managed Income</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Current value:</p>
                        <p>Income:</p>
                      </div>
                      <div className="pot-section">
                        <p>{regularIncome?.miAllocationPercent + "%"}</p>
                        <p>
                          {"£" +
                            addCommas(
                              parseFloat(regularIncome?.miAmount).toFixed(2) // eslint-disable-line
                            )}
                        </p>
                        <p>£{regularIncome?.miCurrentIncome} p/m</p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {regularIncome?.faIncomePercentage > 0 && (
                <Col xs={12} sm={6} lg={6} md={6} xl={4}>
                  <div className="tile">
                    <h3 className="sub-header">Future annuity income</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Current value:</p>
                        <p>Income:</p>
                      </div>
                      <div className="pot-section">
                        <p>{regularIncome?.faIncomePercentage + "%"}</p>
                        <p>
                          {" "}
                          {"£" +
                            addCommas(
                              parseFloat(regularIncome?.faIncomeAmount).toFixed(
                                2 //eslint-disable-line
                              ) //eslint-disable-line
                            )}
                        </p>
                        <p>£{regularIncome?.faiCurrentIncome} p/m</p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {regularIncome?.faPercent > 0 && (
                <Col xs={12} sm={6} lg={6} md={6} xl={4}>
                  <div className="tile">
                    <h3 className="sub-header">Flexi-access</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Current value:</p>
                        <p>Income:</p>
                      </div>
                      <div className="pot-section">
                        <p>{regularIncome?.faPercent + "%"}</p>
                        <p>
                          {" "}
                          {"£" +
                            addCommas(
                              parseFloat(regularIncome?.faAmount).toFixed(2) // eslint-disable-line
                            )}
                        </p>
                        <p>
                          £{regularIncome?.faChoosenAmount}{" "}
                          {regularIncome?.faFequency === "Monthly"
                            ? "p/m"
                            : regularIncome?.faFequency === "Quarterly"
                              ? "p/q"
                              : regularIncome?.faFequency === "HalfYearly"
                                ? "p/6m"
                                : regularIncome?.faFequency === "Annual"
                                  ? "p/y"
                                  : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            <div className=" m-42 d-flex align-items-center justify-content-end mt-1">
              <div className="d-flex align-items-center">
                <div className="value-correct-date mr-2">
                  {" "}
                  Values correct as of {todayDate}
                </div>

                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover
                      id="popover-contained"
                      className="tooltip-popover-section"
                    >
                      <Popover.Body className="tooltip-popover-body">
                        <p>
                          {" "}
                          All the values are estimates, based on the most
                          accurate information available. They include all the
                          contributions paid by you and your employer.
                        </p>
                        <p>
                          The value of your pension savings is based on current
                          financial conditions and is not guaranteed. The
                          amounts you receive may be higher or lower than the
                          amounts shown above. Payment of your pension will be
                          subject to TPT’s Trust Deed and Rules, and regulatory
                          requirements.
                        </p>{" "}
                      </Popover.Body>
                    </Popover>
                  }
                  flip={true}
                >
                  <span className="textarea-tooltip">
                    <Icons iconname="tool-tip" variant="icon-twelve-px" />
                  </span>
                </OverlayTrigger>
              </div>
            </div>
            <hr />
            <div className="your-confirmations mt-4">
              <h3 className="sub-header mb-3">Your confirmations</h3>
              <div className="check-box">
                {checkConfirmations?.map((item, index) => {
                  return (
                    <span key={index}>
                      <CustomCheckbox
                        name={item.checkboxName}
                        type="checkbox"
                        label={item.label}
                        variantName="custom-checkbox mt-3"
                        onChange={() => {
                          if (item.value === "read") {
                            setReadStatus(!readStatus);
                          } else {
                            setRiskStatus(!riskStatus);
                          }
                        }}
                      />
                    </span>
                  );
                })}
              </div>
              <div className="all-money">
                {regularIncome?.miAllocationPercent > 0 && (
                  <p>
                    Managed income -{" "}
                    <a
                      className="risk-warning-links"
                      href="https://tpt.co.uk/risk-warnings"
                      target="_blank"
                      rel="noreferrer"
                    >
                      tpt.co.uk/risk-warnings
                    </a>
                  </p>
                )}
                {regularIncome?.faIncomePercentage > 0 && (
                  <p>
                    Future annuity income -{" "}
                    <a
                      className="risk-warning-links"
                      href="https://tpt.co.uk/risk-warnings"
                      target="_blank"
                      rel="noreferrer"
                    >
                      tpt.co.uk/risk-warnings
                    </a>
                  </p>
                )}
                {regularIncome?.faPercent > 0 && (
                  <p>
                    Flexi-access -{" "}
                    <a
                      className="risk-warning-links"
                      href="https://tpt.co.uk/risk-warnings"
                      target="_blank"
                      rel="noreferrer"
                    >
                      tpt.co.uk/risk-warnings
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>
        ) : chooseRetirementSteps?.isAnnuityHowMuchCash === true ? (
          <div className="take-guranteed-annuity">
            <Row>
              <Col md={7}>
                <div>
                  <h3 className="sub-header">Your retirement choices</h3>
                </div>
                <p className="bold-text">You have chosen an annuity</p>
                <Row>
                  {applicationPotsSelected?.map((item) => (
                    <Col lg={12} md={12} className="mb-3" key={item.potId}>
                      <Row>
                        <Col lg={5} md={5}>
                          Retiring with:
                        </Col>
                        <Col lg={7} md={7} className="bold-text">
                          <span>
                            {item.potId}&nbsp;&nbsp;{item.potName}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} md={5}>
                          Applying with:
                        </Col>
                        <Col lg={7} md={7} className="bold-text">
                          {"£" +
                            addCommas(
                              (
                                item.potValue *
                                potUsedOfTotalIndividualPotTakeAllInOneGo
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} md={5}>
                          Tax-free cash:
                        </Col>
                        <Col lg={7} md={7} className="bold-text">
                          {"£" +
                            addCommas(
                              (
                                item.potValue *
                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                (annuitychoice?.choiceCategory
                                  ?.takeGuaranteedIncomeAnnuity
                                  ?.cashWithdrawPerc /
                                  100)
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={5} md={5}>
                          Buying an annuity with:
                        </Col>
                        <Col lg={7} md={7} className="bold-text">
                          {"£" +
                            addCommas(
                              (
                                item.potValue *
                                  potUsedOfTotalIndividualPotTakeAllInOneGo -
                                item.potValue *
                                  potUsedOfTotalIndividualPotTakeAllInOneGo *
                                  (annuitychoice?.choiceCategory
                                    ?.takeGuaranteedIncomeAnnuity
                                    ?.cashWithdrawPerc /
                                    100)
                              ).toFixed(2) //eslint-disable-line
                            )}
                        </Col>
                      </Row>
                    </Col>
                  ))}
                </Row>
              </Col>
              <Col md={5} className="right-section">
                <div>
                  <h3 className="sub-header">Annuity details</h3>
                </div>
                <Row>
                  <Col md={6}>Annuity provider name</Col>
                  <Col md={6} className="text-end bold-text">
                    {
                      annuityprovider?.choiceCategory
                        ?.takeGuaranteedIncomeAnnuity?.annuityProvider
                    }
                  </Col>
                </Row>

                <div className="second-section mt-3">
                  <div>
                    <h3 className="sub-header">What happens next?</h3>
                    <p>
                      Please ask your provider or financial adviser to share
                      full payment instructions with us, so that we can process
                      your application.
                    </p>
                    <p>
                      You can also upload this at{" "}
                      <Link to="/get-in-touch/" className="getintouch-link">
                        get in touch
                      </Link>
                      .
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        ) : chooseRetirementSteps?.isMixMatchHowMuchCash === true ? (
          <div className="mix-match mt-3">
            <p>You’ve chosen to mix and match your choices</p>
            <p>
              Any taxable cash will be paid from drawdown shortly after the
              tax-free portion.
            </p>
            <p>
              If you are buying an annuity, this money will be held in
              flexi-access until paid, and the final value paid may be higher or
              lower. Please remember to provide full payment instructions from
              your provider.
            </p>
            <div>
              <h3 className="sub-header">Your retirement choices</h3>
            </div>
            <Row>
              {applicationPotsSelected?.map((item) => (
                <Col lg={12} md={12} className="mb-3" key={item.potId}>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Retiring with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      <span>
                        {item.potId}&nbsp;&nbsp;{item.potName}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Applying with:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            item.potValue *
                            potUsedOfTotalIndividualPotTakeAllInOneGo
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Of which tax-free cash:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            mmTaxFreeIndividualPercentage *
                            (item.potValue *
                              potUsedOfTotalIndividualPotTakeAllInOneGo)
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col lg={4} md={4}>
                      Of which taxable cash:
                    </Col>
                    <Col lg={8} md={8} className="bold-text">
                      {"£" +
                        addCommas(
                          (
                            mmTaxableIndividualPercentage *
                            (item.potValue *
                              potUsedOfTotalIndividualPotTakeAllInOneGo)
                          ).toFixed(2) //eslint-disable-line
                        )}
                    </Col>
                  </Row>
                </Col>
              ))}
            </Row>
            <Row className="mt-4 mb-2">
              {mixNMatchIncome?.miPercent > 0 && (
                <Col xl={4} lg={6}>
                  <div className="tile">
                    <h3 className="sub-header">Managed income</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Total value:</p>
                        <p>Income:</p>
                      </div>
                      <div className="pot-section">
                        <p>{mixNMatchIncome?.miPercent + "%"}</p>
                        <p>
                          {"£" +
                            addCommas(
                              (
                                (mixNMatchIncome?.miPercent / 100) *
                                mixMatchSelected
                              ).toFixed(2) // eslint-disable-line
                            )}
                        </p>
                        <p>£{mixNMatchIncome?.miCurrentIncome} p/m</p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {mixNMatchIncome?.faiPercent > 0 && (
                <Col xl={4} lg={6}>
                  <div className="tile">
                    <h3 className="sub-header">Future annuity income</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Total value:</p>
                        <p>Income:</p>
                      </div>
                      <div className="pot-section">
                        <p>{mixNMatchIncome?.faiPercent + "%"}</p>
                        <p>
                          {"£" +
                            addCommas(
                              (
                                (mixNMatchIncome?.faiPercent / 100) *
                                mixMatchSelected
                              ).toFixed(2) // eslint-disable-line
                            )}
                        </p>
                        <p>£{mixNMatchIncome?.faiCurrentIncome} p/m</p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}

              {mixNMatchIncome?.safetynetPercent > 0 && (
                <Col xl={4} lg={6}>
                  <div className="tile">
                    <h3 className="sub-header">Safety net</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Total value:</p>
                      </div>
                      <div className="pot-section">
                        <p>{mixNMatchIncome?.safetynetPercent + "%"}</p>
                        <p>
                          {" "}
                          {"£" +
                            addCommas(
                              (
                                (mixNMatchIncome?.safetynetPercent / 100) *
                                mixMatchSelected
                              ).toFixed(2) // eslint-disable-line
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {mixNMatchIncome?.legacyPercent > 0 && (
                <Col xl={4} lg={6}>
                  <div className="tile">
                    <h3 className="sub-header">Legacy</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Total value:</p>
                      </div>
                      <div className="pot-section">
                        <p>{mixNMatchIncome?.legacyPercent + "%"}</p>
                        <p>
                          {"£" +
                            addCommas(
                              (
                                (mixNMatchIncome?.legacyPercent / 100) *
                                mixMatchSelected
                              ).toFixed(2) // eslint-disable-line
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {mixNMatchIncome?.faPercent > 0 && (
                <Col xl={4} lg={6}>
                  <div className="tile">
                    <h3 className="sub-header">Flexi-access</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Total value:</p>
                        <p>Income:</p>
                      </div>
                      <div className="pot-section">
                        <p>{mixNMatchIncome?.faPercent + "%"}</p>
                        <p>
                          {"£" +
                            addCommas(
                              (
                                (mixNMatchIncome?.faPercent / 100) *
                                mixMatchSelected
                              ).toFixed(2) // eslint-disable-line
                            )}
                        </p>
                        <p>
                          £{mixNMatchIncome.faChoosenAmount}{" "}
                          {mixNMatchIncome?.faFequency === "Monthly"
                            ? "p/m"
                            : mixNMatchIncome?.faFequency === "Quarterly"
                              ? "p/q"
                              : mixNMatchIncome?.faFequency === "HalfYearly"
                                ? "p/6m"
                                : mixNMatchIncome?.faFequency === "Annual"
                                  ? "p/y"
                                  : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {mixNMatchIncome?.annuityPercent > 0 && (
                <Col xl={4} lg={6}>
                  <div className="tile">
                    <h3 className="sub-header">Annuity</h3>
                    <div className="d-flex">
                      <div className="retiring-section">
                        <p>Allocation:</p>
                        <p>Total value:</p>
                        <p>Annuity provider:</p>
                      </div>
                      <div className="pot-section">
                        <p>{mixNMatchIncome?.annuityPercent}%</p>
                        <p>£{mixNMatchIncome?.annuityAmount}</p>
                        <p>{mixNMatchIncome?.annuityProvider}</p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            <div className=" m-42 d-flex align-items-center justify-content-end mt-1">
              <div className="d-flex align-items-center">
                <div className="value-correct-date mr-2">
                  {" "}
                  Values correct as of {todayDate}
                </div>

                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Popover
                      id="popover-contained"
                      className="tooltip-popover-section"
                    >
                      <Popover.Body className="tooltip-popover-body">
                        <p>
                          All the values are estimates, based on the most
                          accurate information available. They include all the
                          contributions paid by you and your employer.
                        </p>
                        <p>
                          The value of your pension savings is based on current
                          financial conditions and is not guaranteed. The
                          amounts you receive may be higher or lower than the
                          amounts shown above. Payment of your pension will be
                          subject to TPT’s Trust Deed and Rules, and regulatory
                          requirements.
                        </p>
                      </Popover.Body>
                    </Popover>
                  }
                  flip={true}
                >
                  <span className="textarea-tooltip">
                    <Icons iconname="tool-tip" variant="icon-twelve-px" />
                  </span>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <Row className="button-container">
          <Col md={6}>
            {" "}
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />
          </Col>
          <Col md={6} className="text-end">
            <Buttons
              handleClick={() => handleContinue()}
              className="primary"
              name="Continue"
              disabled={isDisabled}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ConfirmYourChoices;
